import { useEffect, useRef } from 'react';
export var getContainerByRef = function (containerRef) {
    return (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || {
        getBoundingClientRect: function () { return ({ height: 0, width: 0 }); },
    };
};
export var onResizeContainer = function (containerRef, cb) {
    var _a;
    var container = getContainerByRef(containerRef);
    var containerWidth = ((_a = container.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.width) || 0;
    cb(containerWidth);
};
export var useResizeContainer = function (cb) {
    var containerRef = useRef(null);
    var onResize = function () {
        onResizeContainer(containerRef, cb);
    };
    useEffect(onResize, []);
    useEffect(function () {
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    return containerRef;
};
//# sourceMappingURL=index.js.map